import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import { BRANDS, TYPES } from "CONFIGS";
import { useAppContext } from "../context/app";
import { MODES } from "../configs";

const Standalone = loadable(() => import("./Standalone"));
const Packages = loadable(() => import("./Packages"));
const Flights = loadable(() => import("./Flights"));
const Hotels = loadable(() => import("./Hotels"));
const Cruises = loadable(() => import("./Cruises"));
const SOVMobile = loadable(() => import("./BookingSearchBoxSOVMobile"));

const BookingSearchBox = ({ brand, type, standalone, tabs, mode }) => {
	const [useAppState] = useAppContext();
	if (brand.toLowerCase() === BRANDS.SWG.toLowerCase()) {
		if (standalone) {
			return <Standalone brand={brand} type={type} tabs={tabs} />;
		}

		switch (type.toUpperCase()) {
			case TYPES.CRUISES:
				return <Cruises />;
			case TYPES.HOTELS:
				return <Hotels />;
			case TYPES.FLIGHTS:
				return <Flights />;
			case TYPES.PACKAGES:
			default:
				return <Packages />;
		}
	} else if (brand.toLowerCase() === BRANDS.VWQ.toLowerCase() && type.toUpperCase() === TYPES.PACKAGES) {
		return <Packages />;
	} else if (brand.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		if (useAppState.sovSimplifiedSearchBar) {
			return <SOVMobile brand={brand} type={type} tabs={tabs} />;
		}

		if (standalone) {
			return <Standalone brand={brand} type={type} tabs={tabs} mode={mode} />;
		}

		switch (type.toUpperCase()) {
			case TYPES.CRUISES:
				return <Cruises />;
			case TYPES.HOTELS:
				return <Hotels />;
			case TYPES.FLIGHTS:
				return <Flights />;
			case TYPES.PACKAGES:
			case TYPES.SMALLGROUPS:
			default:
				return <Packages />;
		}
	} else {
		console.error("Booking Search Box configuration not implemented for: ", {
			brand,
			type,
			standalone,
			tabs,
		});

		return null;
	}
};

BookingSearchBox.propTypes = {
	type: PropTypes.string.isRequired,
	standalone: PropTypes.bool,
	mode: PropTypes.string,
	tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

BookingSearchBox.defaultProps = {
	standalone: false,
	mode: MODES.SEARCH
};

export default BookingSearchBox;
export { BookingSearchBox };
